export default class ButtonActive{

    constructor(element){
        this.element = element
        this.buttons = this.element.querySelectorAll('[data-button]')
        this.init()
    }

    init(){
        for(let i = 0; i < this.buttons.length; i++){
            let button = this.buttons[i]
            button.addEventListener("click", this.selectButton.bind(this))
        }
    }

    selectButton(event){
        for(let i = 0; i < this.buttons.length; i++){
            let button = this.buttons[i]
            button.classList.remove('active')
        }

        event.currentTarget.classList.add('active')
    }
}